"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AppLoadersProvider = require("./AppLoadersProvider");
Object.keys(_AppLoadersProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppLoadersProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppLoadersProvider[key];
    }
  });
});
var _useAppLoaders = require("./useAppLoaders");
Object.keys(_useAppLoaders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useAppLoaders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useAppLoaders[key];
    }
  });
});
